import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "include_pipe", standalone: false })
export class IncludeGenericPipe implements PipeTransform {
	transform<T>(list: T[] | null | undefined, item: T | null | undefined): boolean {
		if (!Array.isArray(list) || item === null || item === undefined) {
			return false;
		}

		return list.includes(item);
	}
}
